import { render, staticRenderFns } from "./ConsultarUsuarios.vue?vue&type=template&id=da992dac&scoped=true"
import script from "./ConsultarUsuarios.vue?vue&type=script&lang=ts"
export * from "./ConsultarUsuarios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da992dac",
  null
  
)

export default component.exports